import { Injectable,Inject } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
import { DOCUMENT } from '@angular/common';
@Injectable({"providedIn":"root"})

export class GlobalService {

  constructor(@Inject(DOCUMENT) private doc:any) { }

  loader:boolean = false;  
  loginSubscribe$ = new Subject<any>();
  loginBox$ = new Subject<any>();
  userLoginStatus = new BehaviorSubject(false);
  practiveResolver = new Subject();
  practiveResolver1 = new BehaviorSubject(false);
  seoDetails:any = {};
  bookStep:number = 0;
  headerUpdate$=new Subject<any>();
    
    //==== mm/dd/yyyy 
    dateFormater(date){
      let newDate = new Date(date);
      let d= newDate.getDate();
      let M = newDate.getMonth()+1;
      let y = newDate.getFullYear();
      return `${M}/${d}/${y}`
      
    }

    _calculateAge(DOB) { // birthday is a date
      let birthday = new Date(DOB);
      var ageDifMs = Date.now() - birthday.getTime();
      var ageDate = new Date(ageDifMs); // miliseconds from epoch
      return Math.abs(ageDate.getUTCFullYear() - 1970);
  }

  pageDescriptio(content){
    var m = this.doc.createElement('meta'); 
    m.name = 'description'; 
    m.content = content; 
    this.doc.head.appendChild(m);
  }

  addclassBody(){
    let html = this.doc.getElementsByName('html');
    let body = this.doc.getElementsByName('body');
  }

  dateFormateMMDDYYYY(date){
    let newDate = new Date(date);
    let d= newDate.getDate()<10?`0${newDate.getDate()}`:newDate.getDate();
    let M = newDate.getMonth()+1<10?`0${newDate.getMonth()+1}`:newDate.getMonth()+1;
    let y = newDate.getFullYear();
    return `${M}/${d}/${y}`
    
  }


  validateDOB(dob: string): boolean {
  if (!dob) return false;

  // Expected format MM/DD/YYYY
  const parts = dob.split('/');

  if (parts.length !== 3) {
    return false;
  }

  const month = Number(parts[0]);
  const day = Number(parts[1]);
  const year = Number(parts[2]);

  // Basic checks
  if (
    !month ||
    !day ||
    !year ||
    month < 1 ||
    month > 12 ||
    day < 1 ||
    day > 31 ||
    year < 1900
  ) {
    return false;
  }

  const enteredDate = new Date(year, month - 1, day);
  const today = new Date();

  // Remove time part
  enteredDate.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

  // Validate actual date
  const isValidDate =
    enteredDate.getFullYear() === year &&
    enteredDate.getMonth() === month - 1 &&
    enteredDate.getDate() === day;

  if (!isValidDate) {
    return false;
  }

  // DOB should not be future
  if (enteredDate > today) {
    return false;
  }

  return true;
}


 

  

  


  

}